import 'rxjs/add/operator/toPromise';
import { AngularFirestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { FirebaseApp } from '@angular/fire';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { subscribeOn } from 'rxjs/operators';
import { exit } from 'process';

@Injectable()
export class UserService {
  payroll: string;
  userId: string;
  admins;
  adminUID = ['AdtCOx7aJGORWnliC51b2ckAAZI3', 'XvpvOFQV6sPqRT7wInSUa2fIPok1', 'aQYllEcaF3hz6l472JMdb9mYHzr1',
    'R1uumwTzhsXoC3tG5PDdNlpjRFF2', 'OlxiZuTvryUyL4kQJkEouNh4YVx2', 'BG43XzRDFpWDDj8tQZyovolnzup2', '1OrHnyyHLeOGhqG2UQgv4J2uVK63',
    '2FgK3uSQWdjtMmGqqqbM8piAbDuZ52', 'EqzfraLxXFMhyjrmjt2niNMty2j1', '2Foy93XNC9WANz2KnLwUMdOTnLVlu1', 'EswtIBj7uMQ4xPq824x6vkhvyWc2',
    'fbVdtRqzDyS0j25uXNfD9WCWCT43', 'OlxiZuTvryUyL4kQJkEouNh4YVx2', 'DyJOjULys7hkMSpYlrOsUQUiy7n1', 'hvlsnaSqRWXSGbJdVwS5iPblz8P2',
    'gK3uSQWdjtMmGqqqbM8piAbDuZ52, ccqcq2ncgqQa8tXromu3fz1fALu1'];

  constructor(
    public db: AngularFirestore,
    private afAuth: AngularFireAuth,
    private realtimeDB: AngularFireDatabase
  ) { }

  getCurrentUser() {
    return new Promise<any>((resolve, reject) => {
      const user = firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          resolve(user);
        } else {
          reject('No user logged in!');
        }
      });
    });
  }

  saveUserId(key) {
    this.userId = key;
  }

  getUserId(): string {
    return this.userId;
  }

  getCurrentPayroll() {
    return this.payroll;
  }

  setCurrentPayroll(payroll) {
    this.payroll = payroll;
  }

  updateCurrentUser(value) {
    return new Promise<any>((resolve, reject) => {
      const user = firebase.auth().currentUser;
      user.updateProfile({
        displayName: value.name,
      }).then(res => {
        resolve(res);
      }, err => reject(err));
    });
  }

  checkAdmin() {
    var currentEmail = <String>this.afAuth.auth.currentUser.email;
    this.realtimeDB.list('admins/').valueChanges().subscribe(data => {
      console.log(data);
      Object.keys(data).forEach(user => {
        var incomingEmail = <String>data[user].email;
        if (incomingEmail.toUpperCase() === currentEmail.toUpperCase()) {
          return true;
        }
      });
    }, (error) => {
      console.log(error);
      return false;
    }, () => {
      return false;
    });
    return false;
  }
}